<ng-container *ngIf="!adjustersListLoading && !adjusterLoading && !errorAdjusterList">
  <fieldset>
    <label 
      class="form-label text-nowrap lh-sm mb-0"
      [ngClass]="{'text-danger': adjusterIdSelect.invalid && adjusterIdSelect.touched}"
    >
      Adjuster <span class="required">*</span>
    </label>
    <div class="input-group">
      <select
        #adjusterIdSelect="ngModel"
        class="form-select" 
        [ngClass]="{'is-invalid': adjusterIdSelect.invalid && adjusterIdSelect.touched}"
        [disabled]="claimDto!.isLocked"
        (change)="assignTo()" 
        [(ngModel)]="adjusterId"
        required
      >
        <option [ngValue]="''" [selected]="adjusterId === ''" disabled>[Assign To...]</option>
        <option *ngFor="let adjuster of adjustersList" [ngValue]="adjuster.userId">{{adjuster.name}}</option>
      </select>
      <button class="btn btn-outline-primary btn-bg-white rounded-end" [disabled]="claimDto!.isLocked" (click)="assignToMe()">Assign to Me</button>
      <div class="invalid-feedback lh-sm" *ngIf="adjusterIdSelect.invalid && adjusterIdSelect.touched">
        Please select an adjuster.
      </div>
    </div>
  </fieldset>
</ng-container>
<ng-container *ngIf="errorAdjusterList">
  <p class="text-danger small lh-sm mt-1">An error occurred while getting the adjuster list.</p>
</ng-container>
<ng-container *ngIf="errorAdjusterClaim">
  <p class="text-danger small lh-sm mt-1">An error occurred while getting or setting the adjuster of this claim.</p>
</ng-container>
